const doc = [["VD", "GE", "TI", "BS", "AG", "SG", "BE", "JU", "FR", "ZH", "OW", "NW", "AI", "BL", "GR", "NE", "AR", "ZG", "TG", "SH", "SO", "SZ", "GL", "UR", "LU", "VS"]];
module.exports = doc.length <= 1 ? doc[0] : doc;